import { Card, InputRadio, RadioGroup } from 'ui';
import { makeid } from 'core/utils/utils';
import { PERIOD_MAPPING } from 'core/variables/constant';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import AccordionList2 from '../../lists/components/AccordionList2';
import PeriodForm from './../PeriodForm';

// require('moment/locale/es.js');

const CourseFormSchedule = ({ t, timetable, changeTimetable, courseTimeUnitCurrent, config, timesUnit, enableAdvancedProgramming, course }) => {
  // Si el periodo guardado del curso no existe entre las opciones disponibles, caemos a la primera para no romper
  const [timeUnit, setTimeUnit] = useState(
    (courseTimeUnitCurrent ? timesUnit.find((item) => item.name === courseTimeUnitCurrent) : timesUnit[0]) ?? timesUnit[0]
  );
  const [appliedSameShechule, setAppliedSameShechule] = useState(config && config.appliedSameShechule ? config.appliedSameShechule : false);

  useEffect(() => {
    setTimeUnit((courseTimeUnitCurrent ? timesUnit.find((item) => item.name === courseTimeUnitCurrent) : timesUnit[0]) ?? timesUnit[0]);
  }, [courseTimeUnitCurrent]);

  useEffect(() => {
    if (course?.evaluation_period && timesUnit.length > 0) {
      const mappedPeriod = PERIOD_MAPPING[course.evaluation_period];
      const matchedTimeUnit = timesUnit.find((unit) => unit.name === mappedPeriod);

      if (matchedTimeUnit) {
        setTimeout(() => {
          onChangeTimeUnit(matchedTimeUnit); //TODO: Lo dejo con esto horrible y luego reviso por qué está haciendo falt
        }, 200);
      }
    }
  }, [course, timesUnit]);

  function onChangeTimeUnit(item) {
    setTimeUnit(item);
    let times = [...item.periods];

    if (enableAdvancedProgramming) {
      times = times.map((item, i) => ({
        ...item,
        start_date: timetable[i] ? timetable[i].start_date : '',
        end_date: timetable[i] ? timetable[i].end_date : '',
      }));
    } else {
      times = times.map((item, i) => ({
        ...item,
        start_at: timetable[i] ? timetable[i].start_at : '',
        end_at: timetable[i] ? timetable[i].end_at : '',
        days:
          timetable[i] && timetable[i].days
            ? timetable[i].days
            : [
                {
                  day: 'monday',
                  guid: new Date().getTime(),
                  value: ['08:00', '10:00'],
                },
              ],
      }));
    }
    sendChanges(times, appliedSameShechule);
  }

  function renderAccordion() {
    return <AccordionList2 multi={true} tabs={getParseAccordion()} position="right" iconHide={true} />;
  }

  function onChange(e, name, item, indexPeriod, error) {
    let newTimetable = timetable.map((period) => (period.id === item.id ? { ...period, [name]: e ? moment(e).format('YYYY-MM-DD') : null, error } : period));
    if (indexPeriod === 0 && appliedSameShechule) {
      newTimetable = clone(newTimetable);
    }
    sendChanges(newTimetable, appliedSameShechule);
  }

  function onChangeDays(days, item, indexPeriod) {
    // si es primer periodo y está marcado la misma configuracion para todos:
    let newTimetable = timetable.map((period) => (period.id === item.id ? { ...period, ['days']: days } : period));
    if (indexPeriod === 0 && appliedSameShechule) {
      newTimetable = clone(newTimetable);
    } else {
      setAppliedSameShechule(false);
    }

    sendChanges(newTimetable, appliedSameShechule);
  }

  function clone(timetable) {
    let firstDay = { ...timetable[0] };
    let newTime = [...timetable];
    for (let time of newTime) {
      time.days = firstDay.days.map((item) => ({ ...item, guid: makeid(7) }));
    }
    return newTime;
  }

  function renderBodyUnit(item, i) {
    return (
      <PeriodForm
        key={item.id}
        t={t}
        title={i >= 0 ? '' : t(item.name)}
        id={item.id}
        index={i}
        timeUnit={timeUnit}
        onChange={(e, name, indexPeriod) => onChange(e, name, item, indexPeriod)}
        onChangeDays={(days, indexPeriod) => onChangeDays(days, item, indexPeriod)}
        timetable={timetable}
        applySameShechule={applySameShechule}
        appliedSameShechule={appliedSameShechule}
        enableAdvancedProgramming={enableAdvancedProgramming}
        course={course}
      />
    );
  }

  function getParseAccordion() {
    let itemsToAccordion = [];
    itemsToAccordion = timeUnit.periods.map((item, i) => ({
      title: (
        <div className="course-form-schedule__title-container">
          <span className="course-form-schedule__title">{t(`new-course:${item.name}`)}</span>
        </div>
      ),
      children: renderBodyUnit(item, i),
      defaultExpanded: true,
    }));
    return itemsToAccordion;
  }

  function applySameShechule(e) {
    if (e.target.checked) {
      setAppliedSameShechule(true);
      let newTime = clone(timetable);
      sendChanges(newTime, e.target.checked);
    } else {
      setAppliedSameShechule(false);
      sendChanges(timetable, false);
    }
  }

  function sendChanges(newTime, sameTime) {
    changeTimetable(newTime, sameTime);
  }

  return (
    <div className="course-form-schedule">
      {timesUnit.length > 1 && !courseTimeUnitCurrent && (
        <div className="course-form-schedule__times-unit-container">
          <span className="course-form__form-title course-form__form-title--first" aria-hidden="true">
            {t('common:Set academic period')}
          </span>
          <RadioGroup className="course-form-schedule__times-unit" isLegendHidden legend={t('common:Set academic period')} name="unit-time">
            {timesUnit.map((item) => (
              <InputRadio key={item.name} label={t(item.name)} checked={timeUnit?.name === item.name} onChange={() => onChangeTimeUnit(item)} />
            ))}
          </RadioGroup>
        </div>
      )}

      <div className="course-form-schedule__forms-units">
        {timeUnit?.name === 'Annually' &&
          timeUnit.periods.map((item) => (
            <Card key={item.id} padding="lg">
              {renderBodyUnit(item)}
            </Card>
          ))}
        {timeUnit?.name !== 'Annually' && renderAccordion()}
      </div>
    </div>
  );
};

CourseFormSchedule.propTypes = {
  changeTimetable: PropTypes.func,
  timetable: PropTypes.array,
  courseTimeUnitCurrent: PropTypes.string,
  config: PropTypes.object,
  timesUnit: PropTypes.array,
  enableAdvancedProgramming: PropTypes.bool,
  course: PropTypes.object,
  t: PropTypes.func,
};

CourseFormSchedule.defaultProps = {
  changeTimetable: function () {},
  timetable: [
    {
      days: [],
      guid: new Date().getTime(),
    },
  ],
  enableAdvancedProgramming: false,
  course: {},
};

export default withTranslation(['new-course', 'common'])(CourseFormSchedule);
